import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { postData } from "../api/protectedApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TransactionLayout from "../component/dashboard/TransactionLayout";
import { formatAddress } from "../utils/tableUtils";
import { handleExportData } from "../utils/exportUtils";

const CONTRACT_ADDRESS = "0x55d398326f99059fF775485246999027B3197955";

const SelfTransactions = () => {
  const { address, walletAddress } = useParams();
  const currentAddress = address || walletAddress;

  const [transactions, setTransactions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const fillApiData = async (data) => {
    console.log("fll data ", data?.data);
    const list = data?.data?.list || data?.data?.data || (Array.isArray(data?.data) ? data.data : []);
    setTransactions(Array.isArray(list) ? list : []);
    if (data?.data?.count !== undefined) {
      setTotalCount(data.data.count);
    }
  };

  const callData = async (page) => {
    try {
      setIsLoading(true);
      const res = await postData("/user/check_self_deposit", {
        wallet_address: currentAddress,
        contract_address: CONTRACT_ADDRESS,
      });
      fillApiData(res);
    } catch (err) {
      console.error("ee", err);
      setTransactions([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    callData(currentPage);
  }, [currentPage, currentAddress]);

  const handleExport = (type) => {
    handleExportData({
      endpoint: "/user/check_self_deposit",
      params: {
        wallet_address: currentAddress,
        contract_address: CONTRACT_ADDRESS,
      },
      columns,
      fallbackData: transactions,
      filename: "self_transactions",
      type,
      postDataFn: postData,
      toastFn: toast,
    });
  };

  const filteredTransactions = transactions.filter((t) => {
    const q = searchQuery.toLowerCase();
    return (
      (t.transactionHash && t.transactionHash.toLowerCase().includes(q)) ||
      (t.hash && t.hash.toLowerCase().includes(q)) ||
      (t.from && t.from.toLowerCase().includes(q)) ||
      (t.to && t.to.toLowerCase().includes(q)) ||
      (t.value && t.value.toString().includes(q)) ||
      (t.amount && t.amount.toString().includes(q))
    );
  });

  const columns = [
    { key: "id", label: "ID" },
    { key: "amount", label: "Amount" },
    { key: "from", label: "From" },
    { key: "hash", label: "Hash" },
    { key: "value", label: "Value" },
    { key: "date", label: "Date" },
  ];

  return (
    <TransactionLayout
      title={`Self Transactions ${currentAddress || ""}`}
      subtitle={`Tracking contract deposits for wallet address: ${formatAddress(currentAddress, 10, 8)}`}
      searchQuery={searchQuery}
      onSearchChange={(q) => setSearchQuery(q)}
      searchPlaceholder="Search by address, hash, or amount..."
      onExport={handleExport}
      cardTitle={`Self Transactions ${currentAddress || ""}`}
      cardSubtitle="Real-time on-chain self deposit ledger"
      columns={columns}
      data={filteredTransactions}
      isLoading={isLoading}
      emptyMessage="No Transaction found."
      pagination={{
        currentPage,
        totalCount: totalCount || transactions.length,
        limit: 10,
        onPageChange: handlePageChange,
      }}
    />
  );
};

export default SelfTransactions;